import { DialogType } from '../dialog-service';

export function isDialogInformation(type?: DialogType): boolean {
  return type === DialogType.INFORMATION;
}
